import { createSlice } from '@reduxjs/toolkit'
import name from './name'

export const AudienceOptions = [
  { label: 'Paying users', value: 'paying' },
  { label: 'Non Paying users', value: 'non-paying' }
]

export const ColourSchemeOptions = [
  { label: 'Black Background', value: 'black' },
  { label: 'Purple Background', value: 'purple' },
  { label: 'Green Background', value: 'green' },
  { label: 'Orange Background', value: 'orange' }
]

export const ColourSchemes = {
  black: {
    value: 'black',
    bg: 'black',
    text: 'white',
    btn: 'white',
    btnText: 'black'
  },
  purple: {
    value: 'purple',
    bg: '#DADAFE',
    text: 'black',
    btn: '#5D5BED',
    btnText: 'white'
  },
  green: {
    value: 'green',
    bg: '#F2FCC0',
    text: 'black',
    btn: '#D5E82C',
    btnText: 'black'
  },
  orange: {
    value: 'orange',
    bg: '#FFF2CF',
    text: 'black',
    btn: '#FDBC00',
    btnText: 'black'
  }
}

export const CAMPAIGN_STATUS = {
  live: '1-LIVE',
  scheduled: '2-SCHEDULED',
  archived: '3-ARCHIVED'
}

export const CAMPAIGN_STATUS_VALUE_TO_LABEL = {
  '1-LIVE': 'Live',
  '2-SCHEDULED': 'Scheduled',
  '3-ARCHIVED': 'Archived'
}

export const SectionMap = {
  details: {
    title: 'Details',
    steps: {
      name: {
        name: 'name',
        label: 'Campaign Name'
      },
      priority: {
        name: 'priority',
        label: 'Campaign Priority'
      },
      landingPage: {
        name: 'landingPage',
        label: 'Campaign Landing Page'
      }
    }
  },
  content: {
    title: 'Banners Content',
    steps: {
      title: {
        name: 'title',
        label: 'Banner Title'
      },
      body: {
        name: 'body',
        label: 'Body'
      },
      ctaText: {
        name: 'ctaText',
        label: 'CTA Text'
      },
      ctaLink: {
        name: 'colourScheme',
        label: 'Colour Scheme'
      }
    }
  },
  images: {
    title: 'Campaign Imagery',
    steps: {
      rectangularImg: {
        name: 'rectangularImg',
        label: 'Horizontal image'
      },
      squareImg: {
        name: 'squareImg',
        label: 'Square image'
      }
    }
  }
}

const initialState = {
  campaign: undefined,
  sections: SectionMap
}

// Store
export const campaign = createSlice({
  name,
  initialState,
  reducers: {
    getCampaign: (state, { payload }) => {
      state.campaign = payload.campaign
    },
    setSections: (state, { payload }) => {
      state.sections = payload
    },
    setCampaignDefault: (state) => {
      state.campaign.isDefault = true
    },
    reset: () => initialState
  }
})

export const { getCampaign, setSections, reset, setCampaignDefault } = campaign.actions

export default campaign.reducer
